import { db, storage } from "../Helpers/firebase";
import {
  GET_ALL_CHAT,
  GET_FIREBASE_MSG,
  GET_ALL_DASBOARD_CHAT,
} from "../actions/types";

const initialState = {
  chatData: [],
  loading: true,
  firebaseData: [],
};
// const chatSortedData =
//   chatState?.length > 0 &&
//   chatState.sort(
//     (a, b) =>
//       toCurrentDate(b?.last?.timestamp) - toCurrentDate(a?.last?.timestamp)
//   )
const chatReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_CHAT:
      return {
        ...state,

        chatData: payload.map((obj, i) => {
          let dbData = { ...obj };

          db.collection("messages")
            .doc(obj._id.toString())
            .onSnapshot(async (doc) => {
              // dbData.last = await doc.data();
              const last = await doc.data();
              if (last) {
                dbData.last = last;
              }
              if (last === undefined || !last) {
                dbData.last = {
                  from: "",
                  fromUnread: 0,
                  message: "",
                  timestamp: { nanoseconds: 1, seconds: i + 1 },
                };
              }
            });

          db.collection("messages")
            .doc(obj._id?.toString())
            .collection(obj._id)
            .orderBy("timestamp", "asc")
            .onSnapshot((doc) => {
              let message = [];
              doc.forEach(async (s) => {
                message.push(s.data());

                const unreads = message.filter((val) => val.fromUnread === 0);

                dbData.unreads = unreads.length;
              });
            });

          return dbData;
        }),
        loading: false,
      };
    case GET_ALL_DASBOARD_CHAT:
      return {
        ...state,
        chatData: payload.map((obj, i) => {
          let dbData = { ...obj };

          db.collection("messages")
            .doc(obj._id.toString())
            .onSnapshot(async (doc) => {
              // dbData.last = await doc.data();
              const last = await doc.data();
              if (last) {
                dbData.last = last;
              }
              if (last === undefined || !last) {
                dbData.last = {
                  from: "",
                  fromUnread: 0,
                  message: "",
                  timestamp: { nanoseconds: 1, seconds: i + 1 },
                };
              }
            });

          db.collection("messages")
            .doc(obj._id?.toString())
            .collection(obj._id)
            .orderBy("timestamp", "asc")
            .onSnapshot((doc) => {
              let message = [];
              doc.forEach(async (s) => {
                message.push(s.data());

                const unreads = message.filter((val) => val.fromUnread === 0);

                dbData.unreads = unreads.length;
              });
            });

          return dbData;
        }),
        loading: false,
      };
    case GET_FIREBASE_MSG:
      return {
        ...state,
        firebaseData: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default chatReducer;
